import { render, staticRenderFns } from "./ResearchAreaCard.vue?vue&type=template&id=1d6e5bbb&scoped=true&"
import script from "./ResearchAreaCard.vue?vue&type=script&lang=ts&"
export * from "./ResearchAreaCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResearchAreaCard.vue?vue&type=style&index=0&id=1d6e5bbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e5bbb",
  null
  
)

export default component.exports